import { Component, h, Host, Listen, Prop, State } from '@stencil/core';
import {
  disableScrollBody,
  enableScrollBody
} from '../../../../../apps/website-frontend/src/ts/helpers/body-scroll.helper';
import { StoreInterface } from '../../../../../apps/website/src/app/models/environment.model';
import { REGIONS } from '../../../../../shared/consts/regions.const';
import { sdkLogHelper } from '../../../../../shared/helpers/sdk-log.helper';
import { TrackerEventsEnum } from '../../../../../shared/models/tracker-events.enum';
import { internalAnalyticsHelper } from '../../../../../shared/helpers/internal-analytics.helper';

@Component({
  tag: 'select-region-modal',
  styleUrl: 'select-region-modal.scss'
})
export class SelectRegionModal {
  private userCountryByIp: string;

  @State() isModalShown: boolean = false;

  @Prop() currentRegion: string;
  @Prop() stores: string;
  @Prop() disableConditionalOpen: string;
  @Prop() showClose: string;

  @Listen('getUserCountry', { target: 'window' })
  handleCountryChange(e) {
    const { country } = e['detail'];
    this.userCountryByIp = country.alpha2;

    this.showModal();
  }

  private get _stores(): StoreInterface[] {
    const stores = JSON.parse(this.stores);

    return stores.filter((item: StoreInterface) => item.enabled);
  }

  private get shouldSkipModal(): boolean {
    if (this.isModalShown) {
      return;
    }

    if (this.disableConditionalOpen) {
      return;
    }

    const isIpCountryEqualToCurrRegion = this.userCountryByIp?.toUpperCase() === this.currentRegion?.toUpperCase();

    const isRegionConfirmed = Boolean(window.localStorage.getItem('regionModalConfirmed'));

    return isIpCountryEqualToCurrRegion || isRegionConfirmed;
  }

  @Listen('openChangeRegionModal', { target: 'window' })
  private showModal() {
    if (this.shouldSkipModal) {
      return;
    }

    this.isModalShown = true;
    disableScrollBody();

    internalAnalyticsHelper('popUp', {
      element_name: 'select_region_modal',
      value: 'shown',
    });
  }

  private hideModal(sendAnalytics: boolean = true) {
    this.isModalShown = false;
    sendAnalytics && sdkLogHelper(TrackerEventsEnum.changeStoreBridgeClosePopup, { route: 'bridge_page' });
    enableScrollBody();

    internalAnalyticsHelper('popUp', {
      element_name: 'select_region_modal',
      value: 'closed',
    });
  }

  private onOverlayClicked() {
    this.hideModal();
  }

  private onLinkClicked(event: Event, selectedRegion: string) {
    if (selectedRegion === this.currentRegion) {
      event.preventDefault();
    }

    window.localStorage.setItem('regionModalConfirmed', 'true');
    this.sendEventToTracker(selectedRegion);
    event.stopPropagation();
    this.hideModal(false);
  }

  private getRegionUrl(langCode: string): string {
    return REGIONS.find(item => item?.id === langCode)?.flag;
  }

  private sendEventToTracker(selectedRegion: string) {
    const bridgePage = window.location.href.includes('consultation/');

    if (!bridgePage) {
      return;
    }

    sdkLogHelper(
      selectedRegion === this.currentRegion ? TrackerEventsEnum.selectionRegionTheSameRegion : TrackerEventsEnum.selectionRegion,
      {
        route: 'bridge_page',
        region_from: this.currentRegion,
        region_to: selectedRegion
      });
  }

  render() {
    if (!this.isModalShown) {
      return;
    }

    return <Host class='active'>
      <div class='background' onClick={() => this.onOverlayClicked()} />

      <section>
        <h3>Please choose your location</h3>

        <button class='close-button' aria-label='close' onClick={() => this.hideModal()} />

        <div class='content'>
          {this._stores.map(store =>
            <a class='link'
               href={'/' + store.region}
               onClick={event => this.onLinkClicked(event, store.region)}>
              <img src={this.getRegionUrl(store.region)} alt={store.name} title={store.name} />
              <span>{store.name}</span>
            </a>
          )}
        </div>
      </section>
    </Host>;
  }
}
